import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import uniqueId from 'lodash.uniqueid'; // Type defintitions

import * as TYPES from '../../types';
import { Accordion as BootstrapAccordion, Container, Row, Col } from 'react-bootstrap'; // JSS

import { RichText, Link } from '@sitecore-jss/sitecore-jss-react'; // Design System

import Wrapper from '../wrapper/Wrapper';
import ContentBlockTile from '../content/ContentBlockTile';
import CTALink from '../forms/elements/CTALink';

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion(props, context) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props, context);
    _this.state = {
      active: ''
    };
    _this.uniqeId = uniqueId();
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Accordion, [{
    key: "handleSelect",
    value: function handleSelect(selected) {
      this.setState(function (prevState) {
        return {
          active: prevState.active !== selected ? selected : ""
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.uniqeId;
      var active = this.state.active;
      var _this$props = this.props,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? {} : _this$props$title,
          _this$props$ctaLink = _this$props.ctaLink,
          ctaLink = _this$props$ctaLink === void 0 ? {} : _this$props$ctaLink,
          _this$props$layout = _this$props.layout,
          layout = _this$props$layout === void 0 ? {} : _this$props$layout,
          _this$props$linkType = _this$props.linkType,
          linkType = _this$props$linkType === void 0 ? {} : _this$props$linkType;
      return /*#__PURE__*/React.createElement(Wrapper, {
        layout: layout
      }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ContentBlockTile, _extends({}, this.props, {
        model: title,
        layout: layout
      })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(BootstrapAccordion, {
        onSelect: this.handleSelect
      }, this.props.model.map(function (item, index) {
        var _item$fields$Category;

        var category = (_item$fields$Category = item.fields.Category.fields) === null || _item$fields$Category === void 0 ? void 0 : _item$fields$Category.key.value;
        return /*#__PURE__*/React.createElement("div", {
          className: "cb-accordion__item",
          "data-category": "".concat(id, "-").concat(category),
          key: "".concat(id, "-").concat(index)
        }, /*#__PURE__*/React.createElement(BootstrapAccordion.Toggle, {
          className: "\n                      cb-accordion__toggle\n                      ".concat(active === "".concat(id, "-").concat(index) ? 'is-active' : '', "\n                      "),
          as: "a",
          variant: "link",
          eventKey: "".concat(id, "-").concat(index)
        }, /*#__PURE__*/React.createElement(RichText, {
          field: item.fields.Title,
          tag: "span"
        })), /*#__PURE__*/React.createElement(BootstrapAccordion.Collapse, {
          eventKey: "".concat(id, "-").concat(index),
          isopen: active
        }, /*#__PURE__*/React.createElement("div", {
          className: "cb-accordion__body"
        }, /*#__PURE__*/React.createElement(RichText, {
          field: item.fields.Text,
          tag: "p"
        }))));
      })))), /*#__PURE__*/React.createElement(CTALink, {
        ctaLink: ctaLink,
        alignment: "center",
        linkType: linkType
      })));
    }
  }]);

  return Accordion;
}(React.Component);

;
export default Accordion;